// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1kuP2","fileBtn":"File_fileBtn__3QRkq","closeBtn":"File_closeBtn__1w1FX","fileSelected":"File_fileSelected__1anvT","disabled":"File_disabled__3IakA"};